import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../lib/auth";
import { Header } from "../components/Chrome";
import { toast } from "sonner";

export default function Login() {
  const { login, formatError } = useAuth();
  const [f, setF] = useState({ email: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const u = await login(f.email, f.password);
      toast.success("Welcome back.");
      const dest = loc.state?.from || (u.role === "admin" ? "/admin" : "/portal");
      nav(dest);
    } catch (ex) {
      setErr(formatError(ex.response?.data?.detail) || ex.message);
    } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-paper text-ink">
      <Header />
      <div className="pt-32 pb-24 px-6 md:px-12 lg:px-16 grid grid-cols-1 lg:grid-cols-12 gap-10 min-h-screen">
        <div className="lg:col-span-6 flex flex-col justify-center">
          <div className="overline text-black/50 mb-6">Retailer Portal</div>
          <h1 className="font-display text-6xl md:text-8xl uppercase leading-[0.85] tracking-tighter">
            Log in<br/>to your <em className="font-editorial italic tracking-normal">shelf.</em>
          </h1>
          <p className="mt-8 text-lg max-w-md">Approved retailers only. New here? <Link to="/apply" className="link-underline font-semibold">Apply for an account →</Link></p>
        </div>
        <motion.form
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16,1,0.3,1] }}
          onSubmit={submit}
          className="lg:col-span-5 lg:col-start-8 border border-ink p-8 md:p-10 hard-shadow self-center bg-paper"
          data-testid="login-form"
        >
          <div className="space-y-4">
            <div>
              <label className="overline block mb-2">Email</label>
              <input required type="email" value={f.email} onChange={e => setF({...f, email: e.target.value})} className="field" data-testid="login-email" />
            </div>
            <div>
              <label className="overline block mb-2">Password</label>
              <input required type="password" value={f.password} onChange={e => setF({...f, password: e.target.value})} className="field" data-testid="login-password" />
            </div>
            {err && <div className="text-sm text-soda font-semibold" data-testid="login-error">{err}</div>}
            <button disabled={busy} className="btn-primary w-full" data-testid="login-submit">{busy ? "Signing in…" : "Sign in →"}</button>
          </div>
          <div className="mt-6 text-xs text-black/60">
            New here? <Link to="/apply" className="link-underline font-semibold">Apply for an account →</Link>
          </div>
        </motion.form>
      </div>
    </div>
  );
}
